import React from "react";
import Loader from "shared/loader/1";

const Fallback = () => {
  return (
    <div className="w-full flex justify-center h-screen items-center">
      <Loader />
    </div>
  );
};

export default Fallback;
